import api from '@/api'

class HomePageService {
	static getDataHomePage() {
		return api({
			url: 'data-home-page',
		})
  }

  static getDataLanding() {
    return api({
			url: 'get-data-flavors',
		})
  }

  static getColaborations() {
		return api({
			url: 'colaborations',
		})
  }

  static getOffices() {
		return api({
			url: 'branch-offices',
		})
  }

  static getFlavorDetail(id) {
		return api({
      url: 'flavor-detail',
      params: { id }
		})
  }

  static getCategoriesFlavors() {
    return api({
      url: 'categories-flavors'
    })
  }

  static getSubscriptionProducts() {
    return api({
      url: 'subscription-products'
    })
  }

  static register(data) {
    return api({
      url: 'store-register',
      data: data,
      method: 'post'
    })
  }

  static login(data) {
    return api({
      url: 'login',
      data: data,
      method: 'post'
    })
  }

  static logout() {
    return api({
      url: 'logout',
      method: 'POST'
    })
  }

  static me() {
		return api({
			url: 'me',
			method: 'POST'
		})
  }

  static getProducts(category_id, slug) {
    return api({
      url: `products-by-cat/${category_id}/${slug}`,
    })
  }

  static getProductsBySearch(search) {
    return api({
      url: 'products-by-search',
      params: { search }
    })
  }

  static getPackages() {
    return api({
      url: 'packages'
    })
  }

  static recoverPassword(data) {
    return api({
      url: 'recover-password',
      data,
      method: 'post'
    })
  }

  static getUser(uid) {
    return api({
      url: 'get-user',
      data: { uid: uid },
      method: 'post'
    })
  }

  static changePassword(data) {
    return api({
      url: 'change-password',
      data,
      method: 'post'
    })
  }

  static getConfigSubscription() {
    return api({
      url: 'config-subscription'
    })
  }

}

export default HomePageService
